import { h5SourceArr, maxMobileWidth, Origin, Source } from "@/constants/share";
import ShareMobile from "./Mobile";
import ShareWeb from "./Web";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import formatOrigin from "@/utils/formatOrigin";
import fridayReporter from "@/utils/friday";

export default function Share() {
  const navigate = useNavigate();

  useEffect(() => {
    window.navigate = navigate;
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    // 兼容旧版本分享来源
    const origin = searchParams.get("origin") as Origin;
    const source = searchParams.get("source") as Source;

    const formatedOrigin = formatOrigin(origin);

    const payloadOrigin = h5SourceArr.includes(source) ? source : [Origin.MEETING_PLATE, Origin.MAX_LINK].includes(formatedOrigin) ? formatedOrigin : Source.H5_HOMEPAGE;
    fridayReporter.pushData({
      eventCode: 'summary_h5_summary',
      payload: {
        origin: payloadOrigin
      }
    })
  }, [])

  if (document.documentElement.clientWidth <= maxMobileWidth) {
    return <ShareMobile />;
  }
  return <ShareWeb />;
}
